import lodashGet from 'lodash/get';
import {isIssueInSheet} from './issues-helpers';
import featureFlags, {FEATURE_FLAGS} from './featureFlags';
import {clearPendingThumbnail} from '../app/actions';

export const getPushpinLocationId = issuePushpin => lodashGet(issuePushpin, ['locationIds', 0]);

export const hasPushpinLocationInfo = issuePushpin => lodashGet(issuePushpin, 'locationIds');

export const isPushpinExist = (issueId, pushpinsControl) =>
  pushpinsControl.pushpinExtension &&
  pushpinsControl.pushpinExtension.pushPinManager &&
  pushpinsControl.pushpinExtension.pushPinManager.getItemById(issueId);

export const shouldCreatePushpin = (issue, pushpinsControl, currentSheets) =>
  !isPushpinExist(issue.id, pushpinsControl) && isIssueInSheet(issue, currentSheets);

export const updateIssueWithSnapshotUrn = (jsonApi, issuesV2Api, dispatch, issueId, snapshotUrn, pushpinId) => {
  (featureFlags.get(FEATURE_FLAGS.ISSUES_V2)
    ? issuesV2Api.updateIssue(issueId, {snapshotUrn})
    : jsonApi.updateQualityIssue({id: issueId}, {snapshotUrn})
  )
    .then(() => {
      dispatch(clearPendingThumbnail(pushpinId));
    })
    .catch(() => {
      dispatch(clearPendingThumbnail(pushpinId));
    });
};
